var _path, _line, _line2, _line3, _line4, _ellipse, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcehockey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    xmlSpace: "preserve",
    stroke: "currentColor",
    strokeWidth: 25,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M834.8,95.4L459.5,776.3l-281.7-43c-30.9-4.7-58.1,20.6-55.5,51.8l4.4,54.1c2.1,25.6,23.8,45.1,49.4,44.5 l275.9-6.9c26.8-0.7,51.7-14.2,66.9-36.3l379.3-700.6c6.2-9,3.9-21.2-5-27.4l-31.1-21.8C853.4,84.3,841,86.5,834.8,95.4z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 850.4,
    y1: 216.9,
    x2: 796.3,
    y2: 179
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 824.6,
    y1: 267.4,
    x2: 770.5,
    y2: 229.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 798.8,
    y1: 317.9,
    x2: 744.6,
    y2: 280
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 255.8,
    y1: 745.2,
    x2: 261.1,
    y2: 881.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 744.6,
    cy: 811.8,
    rx: 101.9,
    ry: 43.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M642.7,811.8v82.1c0,23.8,45.6,43.1,101.9,43.1c56.3,0,101.9-19.3,101.9-43.1V817"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcehockey);
export default __webpack_public_path__ + "static/media/Icehockey.828d5444a9f0be5a07cb53a4aecfe73a.svg";
export { ForwardRef as ReactComponent };